import { getEstateProps, createEstate, attachFile, attachFileUpdate, updateEstate, getListEstates, getSingleEstate, setState } from '@services/estate/estateDataService';
import { setCache, getCache, deepEqual, currentLang, } from '@/helpers';
import { setSnackbar } from '@/helpers';
import estateStoreActions from '@constans/store/estate/estateStoreActions';
import estateStoreMutations from '@constans/store/estate/estateStoreMutations';
import globalStoreActions from '@constans/store/global/globalStoreActions';
const actions = {
    async [estateStoreActions.LIST_ESTATES]({ commit }, payload) {
        await getListEstates(payload).then(response => {
            if (response.status === 'Success') {
                const cache = getCache();
                // Append user to cache
                cache.estateList = response.data;
                // Set cache
                setCache(cache);
                // Populate store
                commit(estateStoreMutations.SET_ESTATE_LIST, response.data);
            }
        });
    },
    async [estateStoreActions.GET_FORM_PROPS]({ commit }) {
        await getEstateProps().then(response => {
            if (response.status === 'Success') {
                const data = response.data;
                let results = [];
                data.available_prop_descriminator.forEach(key => results.push({
                    key: key,
                    data: data.related_prop[key].filter((i) => i.available === true)
                }));
                commit(estateStoreMutations.SET_FORM_PROPS, results);
            }
        });
    },
    async [estateStoreActions.CREATE_ESTATE]({ state, dispatch }) {
        const result = await createEstate(state.payload).then(response => {
            const snackbar = setSnackbar(response);
            snackbar.message = currentLang === 'sv'
                ? 'Bostaden skapades'
                : 'Estate was successfully created';
            dispatch(`global/${globalStoreActions.SET_SNACKBAR}`, snackbar, { root: true });
            return true;
        }).catch(err => {
            if (err.status === 'Error') {
                dispatch(`global/${globalStoreActions.SET_SNACKBAR}`, setSnackbar(err), { root: true });
            }
            return false;
        });
        return result;
    },
    async [estateStoreActions.ATTACH_FILE]({ state, commit }) {
        if (state.payload.attachment_payload.length > 0) {
            const result = await attachFile({
                attachment_files: state.payload.attachment_payload
            }).then(response => {
                if (response.status === 'Success' && response.data.length > 0) {
                    response.data.forEach((file, index) => {
                        const position = state.payload.attachment_payload[index] ? state.payload.attachment_payload[index].index : index;
                        commit(estateStoreMutations.SET_UPLOADED_IMAGE, [file, position]);
                    });
                }
                return response.status === 'Success';
            });
            return result;
        }
        return true;
    },
    async [estateStoreActions.ATTACH_UPDATE]({ state, commit }) {
        if (state.payload.attachment_update.length > 0) {
            const result = await attachFileUpdate({
                attachment_files: state.payload.attachment_update
            }).then(response => {
                if (response.status === 'Success' && response.data.length > 0) {
                    commit(estateStoreMutations.UPDATE_ATTCHED_FILE, response.data);
                }
                return response.status === 'Success';
            });
            return result;
        }
        return true;
    },
    async [estateStoreActions.UPDATE_ESTATE]({ state, dispatch }) {
        const result = await updateEstate(state.payload).then(response => {
            const snackbar = setSnackbar(response);
            snackbar.message = currentLang === 'sv'
                ? 'Bostaden uppdaterades'
                : 'Estate was successfully updated';
            dispatch(`global/${globalStoreActions.SET_SNACKBAR}`, snackbar, { root: true });
            return true;
        }).catch(err => {
            if (err.status === 'Error') {
                dispatch(`global/${globalStoreActions.SET_SNACKBAR}`, setSnackbar(err), { root: true });
            }
            return false;
        });
        return result;
    },
    async [estateStoreActions.GET_ESTATE]({ dispatch, commit }, estateId) {
        const result = await getSingleEstate(estateId).then((response) => {
            if (response.status === 'Success') {
                let cache = getCache();
                let estateCacheWasUpdated = false;
                // Update local cache with newly fetched estate
                cache.estateList.estates = cache?.estateList?.estates.map((estate) => {
                    if (estate.id !== response.data.id) {
                        return estate;
                    }
                    if (deepEqual(estate, response.data)) {
                        return estate;
                    }
                    estateCacheWasUpdated = true;
                    return {
                        ...estate,
                        ...response.data
                    };
                });
                commit(estateStoreMutations.SET_SINGLE_ESTATE_LIST, response.data);
                if (estateCacheWasUpdated) {
                    // Set cache
                    setCache(cache);
                    commit(estateStoreMutations.SET_ESTATE_LIST, cache.estateList);
                }
            }
            return true;
        }).catch(() => false);
        return result;
    },
    async [estateStoreActions.GET_ESTATE_FROM_UUID]({ dispatch, commit }, estateUuid) {
        const result = await getSingleEstate(estateUuid).then((response) => {
            if (response.status === 'Success') {
                commit(estateStoreMutations.SET_SINGLE_ESTATE_LIST, response.data);
            }
            return true;
        }).catch(() => false);
        return result;
    },
    [estateStoreActions.SET_STATE]: async ({ dispatch, commit }, obj) => {
        const result = await setState(obj).then(response => {
            if (response.status === 'Success') {
                const cache = getCache();
                const estate = cache.estateList.estates.find((e) => e.id === obj.estateId);
                if (estate) {
                    estate.state = Number(obj.stateId);
                    setCache(cache);
                }
                commit(estateStoreMutations.SET_STATE, response.data);
                const snackbar = setSnackbar(response);
                snackbar.message = currentLang === 'sv'
                    ? 'Statusen uppdaterades'
                    : 'Status was updated';
                dispatch(`global/${globalStoreActions.SET_SNACKBAR}`, snackbar, { root: true });
            }
        });
        return result;
    }
};
export default actions;
